import { defineStore } from 'pinia'
import { useAuthStore } from '@sto/auth.store'
import * as CheckService from '@ser/check'
import {listForAsset, update} from "@ser/check";

export const useCheckStore = defineStore('check', {

    state: () => {
        return {
            _foo: 'foo'
        }
    },

    getters: {
        foo: state => state._foo,
    },

    actions: {
        /**
         * get a specific check
         */
        async show(check_id) {
            return CheckService.show(check_id)
        },

        /**
         * update a specific check
         */
        async update(check_id, data) {
            return CheckService.update(check_id, data)
        },

        /**
         * delete a specific check
         */
        async deleteCheck(check_id) {
            return CheckService.deleteCheck(check_id)
        },

        /**
         * manually create a check for an asset
         */
        async createForAsset(asset_id, data) {
            return CheckService.createForAsset(asset_id, data)
        },

        /**
         * list a single asset's checks
         * @param asset_id
         * @param param
         * @returns {Promise<obj>}
         */
        async listForAsset(asset_id, params = []) {
            return CheckService.listForAsset(asset_id, params)
        },

        /**
         * user is manually entering a HPI insurance check
         * @param asset_id
         * @param category
         * @param summary
         * @returns {Promise<obj>}
         */
        async createAssetInsuranceCheck(asset_id, type, category = 'clear', event_date = null, summary = null) {

            let label,
                status

            switch (category) {
                case "tba":
                    label = "TBA"
                    status = "tba"
                    break
                case "clear":
                    label = "Clear"
                    status = "clear"
                    break
                default:
                    label = `Category ${category}`
                    status = "alert"
            }

            return CheckService.createForAsset(asset_id, {
                source: "manual",
                status,
                label,
                type,
                event_date,
                summary
            })
        }

    }
})